import { Button, Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React, { useContext, useEffect, useState, useMemo, Fragment } from 'react';
import { withRouter } from 'react-router';
import 'react-virtualized/styles.css';
import { OrderReviewContext } from '../OrderReviewContext';
import FORM_HEADERS from '../../../enums/formHeaders';
import { getCommercialNarrativeRiskTypes, getCommercialNarratives } from '../../../services/orderReview.service';
import Select from '../../FormFields/Select';
import FormDefinition from '../FormDefinition';
import ReactSelectWrapper from '../ReactSelectWrapper';
import ReactSelect from 'react-select';
import { Label } from 'react-konva';
import { TextArea } from '../../DynamicForm/FormInputs';
import { cloneDeep } from 'lodash';
import { InputLabel } from '@material-ui/core';

const BlackInputLabel = withStyles({
  root: {
    color: 'black',
    display: 'flex',
    justifyContent: 'start',
    padding: '8px 0 8px 0',
    fontWeight: 'bold',
  },
})(InputLabel);

const styles = theme => ({
  header: {
    fontSize: '1.1rem',
    fontWeight: '700',
    textAlign: 'center',
    color: '#fff',
    backgroundColor: 'var(--jmi-blue)',
    padding: '0.5rem',
    marginBottom: '24px',
  },
  formDefinitionWrapper: {
    padding: '24px 24px 0 24px',
  },
});

export const CommercialNarratives = withStyles(styles)(
  ({ classes, formDefinitions, saveAnswersAsync, removeAnswersAsync, editPropertyCharacteristics }) => {
    const { state, dispatch } = useContext(OrderReviewContext);
    const [riskTypes, setRiskTypes] = useState([]);
    const [selectedValue, setSelectedValue] = useState({});
    const [narratives, setNarratives] = useState([]);
    const [notesValue, setNotesValue] = useState('');

    const isCommercialNarrative =
      state.formHeaders[state.activeFormHeaderIndex].formHeaderId === FORM_HEADERS.COMMERCIAL_NARRATIVES ||
      state.formHeaders[state.activeFormHeaderIndex].formHeaderId === FORM_HEADERS.COMMERCIAL_NARRATIVES_OB;

    useEffect(() => {
      const fetchRiskTypes = async () => {
        const riskTypes = await getCommercialNarrativeRiskTypes();

        setRiskTypes(
          riskTypes.map(x => {
            return { value: x.commercialRiskTypeId, label: x.name };
          }),
        );
      };
      fetchRiskTypes();
    }, []);

    const valueChanged = evt => {
      // TODO.babyjay: wouldn't use a callback here, just set the value
      setSelectedValue(riskTypes.find(x => x.value === evt.value));
    };

    useEffect(() => {
      const fetchNarratives = async () => {
        const narratives = await getCommercialNarratives(selectedValue.value);
        const filteredNaratives = narratives.filter(x => !x.readOnly);
        setNarratives(filteredNaratives);

        const note = narratives.find(x => x.readOnly)?.value;
        setNotesValue(note);
      };
      fetchNarratives();
    }, [selectedValue]);

    const handleClick = () => {
      const formheader = state?.formHeaders?.find(x => {
        return (
          x.formHeaderId === FORM_HEADERS.COMMERCIAL_NARRATIVES ||
          x.formHeaderId === FORM_HEADERS.COMMERCIAL_NARRATIVES_OB
        );
      });

      const updates = narratives.map(element => ({
        questionId: element.commercialNarrativeType.questionId,
        newAnswers: [
          {
            orderFormHeaderId: formheader.orderFormHeaderId,
            formDefinitionId: formheader.formDefinitions.find(
              x => x.questionId === element.commercialNarrativeType.questionId,
            )?.formDefinitionId,
            questionId: element.commercialNarrativeType.questionId,
            formQaAnswerId: null,
            type: 'TextArea',
            valueId: null,
            value: null,
            text: element.value,
            modifiedOn: new Date(),
            images: [],
            default: false,
          },
        ],
        orderFormHeaderId: formheader.orderFormHeaderId,
      }));

      const newAnswers = updates.flatMap(u => u.newAnswers);

      dispatch({
        type: 'UPDATE_ANSWERS',
        updates,
      });

      saveAnswersAsync(newAnswers);
    };

    const handleOnChange = evt => {
      const updatedNarratives = cloneDeep(narratives);
      const updateIndex = narratives.findIndex(x => x?.commercialNarrativeId == evt.target.id);

      if (updateIndex !== -1) {
        updatedNarratives[updateIndex].value = evt.target.value;
      }

      setNarratives(updatedNarratives);
    };

    return (
      // TODO.babyjay: keep computed stuff like this up in computed variable above instead of spread across the render phase
      isCommercialNarrative && (
        <Grid container>
          <Grid xs={6}>
            <Grid container>
              <Grid item xs={3}></Grid>
              <Grid item xs={6} style={{ marginTop: 20 }}>
                <BlackInputLabel
                  id="select-label"
                  className={{ color: 'black', display: 'flex', justifyContent: 'center' }}
                >
                  Narrative Templates
                </BlackInputLabel>
                <ReactSelect
                  options={riskTypes}
                  value={selectedValue}
                  onChange={valueChanged}
                  style={{ marginTop: 10 }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <Fragment>
              {notesValue && (
                <Card style={{ marginTop: 15 }}>
                  <CardContent>{notesValue}</CardContent>
                </Card>
              )}
            </Fragment>
            <Fragment>
              {!!narratives.length && (
                <Card style={{ marginTop: 15 }}>
                  <CardContent>
                    {narratives.map(x => (
                      <Grid item xs={12}>
                        <span style={{ marginBottom: 5, fontWeight: 600, float: 'left' }}>
                          {x.commercialNarrativeType.name}
                        </span>
                        <textarea
                          value={x?.value}
                          classes={classes}
                          onChange={handleOnChange}
                          style={{ marginBottom: 15, width: '100%', resize: 'vertical' }}
                          rows={15}
                          id={x?.commercialNarrativeId}
                        />
                      </Grid>
                    ))}
                    <Button
                      onClick={handleClick}
                      style={{
                        backgroundColor: '#315382',
                        color: 'white',
                        marginTop: 20,
                      }}
                      variant="contained"
                    >
                      Migrate to Answers
                    </Button>
                  </CardContent>
                </Card>
              )}
            </Fragment>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.formDefinitionWrapper}>
              {formDefinitions
                .sort((a, b) => a.sequence - b.sequence)
                .map(fd => (
                  <FormDefinition
                    key={fd.formDefinitionId}
                    saveAnswers={saveAnswersAsync}
                    removeAnswers={removeAnswersAsync}
                    formDefinition={fd}
                    isReadOnly={editPropertyCharacteristics}
                    inputStyle={{ maxWidth: 'unset' }}
                  />
                ))}
            </div>
          </Grid>
        </Grid>
      )
    );
  },
);
